import { hotelReducerState } from "./hotelTypes";
import { hotelActionTypes } from "./hotelTypes";

// conversationReducer.ts

const initialState: hotelReducerState = {
    hotel: null,
    rooms: null,
    // booked_rooms: [],
    loading: false,
    error: null,
};

const hotelReducer = (state = initialState, action: any): hotelReducerState => {
    switch (action.type) {
        case hotelActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case hotelActionTypes.INSERT_HOTEL:
                    console.log("[hotelReducer.ts] INSERT_HOTEL success case triggred", action.payload);

                    return {
                        ...state,
                        hotel: action.payload.data.insert_hotel,
                        rooms: action.payload.data.insertedRooms,

                        loading: false
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };

                case hotelActionTypes.UPDATE_HOTEL:
                    console.log("[hotelReducer.ts] UPDATE_HOTEL success case triggred", action.payload);

                    return {
                        ...state,
                        // hotel: action.payload.data.insert_hotel,

                        loading: false
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case hotelActionTypes.GET_HOTEL:
                    console.log("[hotelReducer.ts] GET_HOTEL success case triggred", action.payload);

                    return {
                        ...state,
                        hotel: action.payload.data.hotel_fetched,
                        rooms: action.payload.data.rooms,

                        loading: false
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };

                case hotelActionTypes.DELETE_HOTEL_DATA:
                    console.log("[hotelReducer.ts] DELETE_HOTEL_DATA success case triggred", action.payload);

                    return {
                        ...state,


                        loading: false

                    };





                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }

        case hotelActionTypes.API_RESPONSE_ERROR:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case hotelActionTypes.INSERT_HOTEL:
                    console.log("[hotelReducer.ts] INSERT_HOTEL errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };

                case hotelActionTypes.UPDATE_HOTEL:
                    console.log("[hotelReducer.ts] UPDATE_HOTEL errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"

                    };


                case hotelActionTypes.GET_HOTEL:
                    console.log("[hotelReducer.ts] GET_HOTEL errror case triggred", action.payload);

                    return {
                        ...state,
                        hotel: null,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"

                    };

                case hotelActionTypes.DELETE_HOTEL_DATA:
                    console.log("[hotelReducer.ts] DELETE_HOTEL_DATA errror case triggred", action.payload);

                    return {
                        ...state,

                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"

                    };



                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }



        case hotelActionTypes.INSERT_HOTEL:
            console.log("[hotelReducer.ts] INSERT_HOTEL pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case hotelActionTypes.UPDATE_HOTEL:
            console.log("[hotelReducer.ts] UPDATE_HOTEL pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };


        case hotelActionTypes.GET_HOTEL:
            console.log("[hotelReducer.ts] GET_HOTEL pre api case triggred", action.payload);

            return {
                ...state,

                hotel: null,
                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case hotelActionTypes.DELETE_HOTEL_DATA:
            console.log("[hotelReducer.ts] DELETE_HOTEL_DATA pre api case triggred", action.payload);

            return {
                ...state,

                // hotel: null,
                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };
        // pre api cases
        default:
            return state;
    }
};


export default hotelReducer;
